import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

export interface UserInfoDataType {
  userId: string;
  loginId: string;
  username: string;
  roles: string;
  email: string;
  lastLoginDate: string;
  isSuperuser?: boolean;
}

const useUserStore = create(
  devtools(
    persist(
      (set: any) => ({
        userInfoData: {
          userId: "",
          loginId: "",
          username: "",
          roles: "",
          email: "",
          lastLoginDate: "",
          isSuperuser: false,
        },
        setUserInfoData: async (data: UserInfoDataType) => {
          set({ userInfoData: data });
        },
        clearUserInfoData: async () => {
          set({
            userInfoData: {
              userId: "",
              loginId: "",
              username: "",
              roles: "",
              email: "",
              lastLoginDate: "",
              isSuperuser: false,
            },
          });
        },
      }),
      { name: "UserStore", storage: createJSONStorage(() => sessionStorage) }
    )
  )
);

export default useUserStore;
